<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Resultados de exames"
    >
        <ListResultadoExame
            :data="data"
            readonly
        />

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import ListResultadoExame from '@/components/ambulatorio/atendimento/components/soap/components/objetivo/components/resultado-exame/List'

export default {
    components: {ListResultadoExame},
    methods: {
        open() {
            this.$refs.RkmModal.show()
        },
    },
    props: {
        data: {required: true, type: Object},
    },
}
</script>